<template>

  <div class="person">

    <section class="person_summary">

      <div>
        <p class="person_no">{{step}}</p>
      </div>

      <div class="person_desc">
        <h3>{{step_title}}</h3>
      </div>

      <div class="person_controls">
        <a href="#edit" role="button" class="secondary" v-on:click.prevent="toggle_edit">Edit</a>
        <a href="#delete" role="button" class="secondary" v-on:click.prevent="remove_step">Delete</a>
      </div>

    </section>

    <section v-if="editing" class="form person_form">
      <Input_File
          v-bind:label="field_document_description.label" v-bind:index="index" v-bind:name="field_document_description.name" v-bind:value="value_document_description" v-bind:file="value_file_name.file" v-bind:file_field="field_file" v-on:uploaded="update_step( 'file', $event, false );" v-on:changed="update_step( 'document_description', $event, false)"
      ></Input_File>

      <div class="button_row">
        <a href="#save" class="primary" role="button" v-on:click.prevent="toggle_edit">Ok</a>
        <a href="#cancel" role="button" v-on:click.prevent="toggle_edit">Cancel</a>
      </div>

    </section>

  </div>
</template>

<script>

import Input_File from "@/components/Input_File";

export default {
  name: "Appendix",
  props: {
    index: Number,
    step_count: Number,
    value: Object,
    fields_config: Array
  },
  watch:  {
    step_count: function()  {
      this.editing = false;
    }
  },
  data: function()  {
    return {
      step_description: this.$props.description,
      editing: false,
      field_document_description: null,
      field_file: null,
    }
  },
  mounted() {

    for ( let i = 0; i < this.fields_config.length; i++ ) {

      const f = this.fields_config[ i ];

      if( f.name === 'document_description' ) {

        this.field_document_description = f;

      } else if( f.name === 'file' )  {

        this.field_file = f;

      }

    }

    this.editing = true;

  },
  computed: {

    step_title: function()  {

      if( this.value.document_description !== '' ) {

        return this.value.document_description;

      }

      return 'Unnamed';

    },

    value_document_description : function()  {

      return {
        file_name: this.value.document_description,
        file: this.value.file
      }

    },

    value_file_name : function()  {

      return {
        file_name: this.value.file_name,
        file: this.value.file
      }

    },

    step: function()  {

      return 'Appendix #' + ( this.index + 1 );

    }

  },
  methods: {

    toggle_edit: function() {

      if( this.editing )  {

        this.editing = false;

      } else  {

        this.editing = true;

      }

    },

    remove_step: function() {

      const payload = {
        index: this.index
      }

      this.$emit( 'remove_step', payload );

    },

    update_step: function( key, data, close ) {

      if( close ) {

        this.toggle_edit();

      }

      let payload = {
        index: this.index,
        data: {
          document_description: this.value.document_description,
          file: this.value.file
        }
      };

      payload.data[ key ] = data.value;

      this.$emit( 'update_step', payload );

    }

  },
  components: { Input_File }
}
</script>

<style scoped>

</style>